import { LOCALES } from 'fractals'

export const IMG_ALT = {
  [LOCALES.en]: 'Person studying',
  [LOCALES.ru]: 'Человек учится',
  [LOCALES.uz]: 'Oʻquvchi',
  [LOCALES.kk]: 'Оқушы'
}
